import React from "react";

import {
  List,
  Datagrid,
  TextField,
  SelectField,
  DateField,
  EditButton,
  ShowButton,
  DeleteWithConfirmButton,
} from "react-admin";
import { EmptyList } from "common/components";
import { CreateActions } from "utils/customActions";
import { dateOptions, languageChoices, buyerProfileType } from "utils/options";
const ListBuyerProfiles = () => {
  return (
    <List actions={<CreateActions />}>
      <Datagrid
        bulkActionButtons={false}
        empty={<EmptyList />}
      >
        <TextField
          label="№"
          source="id"
          sortable={false}
        />
        <TextField
          label="Заглавие"
          source="title"
          sortable={false}
        />
        <SelectField
          label="Език"
          source="language"
          choices={languageChoices}
        />
        <DateField
          locales={"bg"}
          options={dateOptions}
          label="Начална дата"
          source="started_on"
          sortable={false}
        />
        <SelectField
          label="Тип обява"
          source="buyer_profile_type"
          choices={buyerProfileType}
          sortable={false}
        />
        <ShowButton />
        <EditButton />
        <DeleteWithConfirmButton />
      </Datagrid>
    </List>
  );
};

export default ListBuyerProfiles;
